<div class="user-menu_container" [class.active]="isUserMenuActive || isBurgerMenuActive" >
  <div class="user-menu">
    <div class="user-icon" [class.burger]="isBurgerMenuActive" [style.background-image]="profileImage" (click)="userIconClick($event)"></div>
    <button class="menu-btn" (click)="burgerIconClick($event)">
      <img alt="Menu" [style]="!(isOpened && isBurgerMenuActive) ? '' : 'height: 13px;'" [src]="!(isOpened && isBurgerMenuActive) ? 'assets/icons/menu.svg' : 'assets/icons/close-icon.svg'">
      <span class="u-hidden-visually" fiTranslation="ALT_TEXT_MAIN_MENU"></span>
    </button>
  </div>

  <div class="burger-popup" [class.opened]="isOpened && isBurgerMenuActive" (click)="$event.stopPropagation();">
    <ul class="burger-inner">
      @if (enableReporting) {
        <li [hasHTMLTags]="true" fiTranslation="HEADER_LINK_REPORTING">
        </li>
      }

      <li [hasHTMLTags]="true" fiTranslation="HEADER_LINK_SUPPORT">
      </li>
    </ul>

    <div class="link-container">
      <a href="https://www.finstral.com/" target="_blank">Finstral.com</a>
    </div>
  </div>

  <div class="user-popup" [class.opened]="isOpened && isUserMenuActive" (click)="$event.stopPropagation();">
    <div class="user-popup-inner">
      <div class="close-btn-mobile" (click)="closeOverlay($event)">
        <img alt="Close" src="/assets/icons/close-icon.svg">
      </div>

      <div class="user-info">
        <div class="user-icon popup-icon" [style.background-image]="profileImage"></div>

        <div class="text-info">
          <p class="name">{{ profileData?.User?.FirstName + ' ' + profileData?.User?.LastName }}</p>
          <p class="job">{{ profileData?.User.Organisation }}</p>
        </div>
      </div>

      <ul class="user-configurations-list">
        <li class="list-item">
          <a routerLink="/profile" class="list-item-link" (click)="closeOverlay($event)">
            <div class="icon">
              <img src="assets/icons/user-black.svg" alt="" #user [isTitle] = "true" fiTranslation="ALT_TEXT_USER_PROFIL" matTooltip="{{user.dataset.matTooltip}}" matTooltipPosition="below" matTooltipClass='tooltip-style'>
            </div>
            <p class="text" fiTranslation="USER_PROFILE_EDIT"></p>
          </a>
        </li>
      </ul>

      <div class="close-btn-container">
        <div class="close-btn" (click)="logout($event)">
          <span fiTranslation="BUTTON_LOGOFF"></span>
        </div>

        <div class="is-update-snippet custom" fiTranslation="USER_PROFILE_PRIVACY_LINK" [hasHTMLTags]="true">

        </div>
      </div>
    </div>
  </div>
</div>


<div class="overlay" [class.active]="isUserMenuActive" (click)="closeOverlay($event)"></div>
